import { render, staticRenderFns } from "./RecordsList.vue?vue&type=template&id=366e2059&scoped=true"
import script from "./RecordsList.vue?vue&type=script&lang=js"
export * from "./RecordsList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "366e2059",
  null
  
)

export default component.exports